<template>
  <div v-if="brains" class="advanced_container">
    <div class="advanced_block-wrapper">
      <h2 class="advanced_title">Advanced</h2>
    </div>
    <div class="advanced_block-wrapper attention_block">
      <p class="advanced_attention">Attention needed</p>
      <p class="advanced_attention text">
        There can be some advanced settings that can show up here. Do not change
        these if you don't know what these are.
      </p>
    </div>
    <div class="advanced_block-wrapper header">
      <p class="advanced_block-title">Control Al Bot's creativity</p>
      <p class="advanced_description">
        Choose how conservative or creative AI Bot can be when generating
        answers from your existing content.
      </p>
      <ul class="advanced-radio-list">
        <li v-for="item in creativityOptions" class="advanced-radio-list__item">
          <CustomRadio
            :value="item?.value"
            :descriptionText="item?.description"
            :handleChange="handleChange"
            :id="item?.id"
            name="creativity"
            customClass="radio_border"
            customClass_flex="radio_flex"
            customClass_header="radio_header"
            customClass_desc="radio_desc"
            :checked="brains?.advanced?.creativity == item?.id"
          />
        </li>
      </ul>
    </div>
    <div class="advanced_block-wrapper header">
      <p class="advanced_block-title">TopP</p>
      <p class="advanced_description">
        Between 0 and 1.<br> 
        Circumscribes the domain of choice (allowing or excluding less likely options to play at all).
      </p>
      <ul class="advanced-radio-list bottom-radio">
        <li v-for="item of topPoptions" class="advanced-radio-list__item">
          <CustomRadio
            name="topP"
            :handleChange="handleChange"
            :checked="item == brains?.advanced?.topP"
            :value="item"
            :id="item" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import CustomRadio from "../../components/shared/UI/CustomRadio.vue";
import ButtonWithLoadWebsite from "../../components/shared/ButtonWithLoadWebsite.vue";

export default {
  props: {
    brains: {
      advanced: {
        creativity: Number,
        topP: Number
      }
    },
    getChanges: Function
  },
  data() {
    return {
      topPoptions: [0, 0.25, 0.5, 0.75, 1],
      creativityOptions: [
        {
          value: 'Conservative (Recommended)',
          id: 0,
          description: 'Will summarize and rephrase from your content.'
        },
        {
          value: 'Avarage creativity',
          id: 0.4,
          description: 'Will generate responses primarily based on your content, but can also draw from from public sources.'
        },
        {
          value: 'Creative',
          id: 0.8,
          description: 'Will generate responses based on avarage beetwen your content and public sources.'
        },
      ]
    }
  },
  components: {
    CustomRadio,
    ButtonWithLoadWebsite
  },
  methods: {
    handleChange(e) {
      const {name, id} = e.target;

      this.$props.getChanges('advanced', {...this.brains.advanced, [name]: id})
    },
  },
};
</script>

<style lang="scss">
.advanced_container {
  
}

.advanced_title {
  color: #333;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.advanced_description {
  color: #bdbdbd;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.advanced_block-wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;

  &.header {
    gap: 8px;
  }
}

.advanced_block-title {
  color: #333;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
}

.advanced_attention {
  color: #637381;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;

  &.text {
    font-weight: normal;
  }
}

.attention_block {
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: 1px dashed #ffa722;
  background: #feffe4;
  padding: 32px;

  @media (min-width: 768px) {
      width: 70%;
    }

    @media (min-width: 1480px) {
      width: 60%;
    }
}

.advanced-radio-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 440px;

  &.bottom-radio {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    /* flex-wrap: wrap;
    flex-direction: row; */
    max-width: none;
    width: fit-content;

    @media (min-width: 400px) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media (min-width: 460px) {
      grid-template-columns: repeat(4, 1fr);
    }

    @media (min-width: 570px) {
      grid-template-columns: repeat(5, 1fr);
    }
  }
}

.radio_flex {
  display: flex;
  flex-direction: column;
}

.radio_border {
  justify-content: start !important;
  border-radius: 10px !important;
  border: 1px solid #d1d1d6;
  background: #fff !important;
  width: 100% !important;
  transition: all 150ms linear;

  &:focus-visible,
  &:hover {
      border-color: rgb(49, 130, 206);
      box-shadow: rgb(49, 130, 206) 0px 0px 0px 1px;
  }
}
.radio_title {
  color: #1d1f20;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.radio_desc {
  color: #828282;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>
